import React from 'react'

const Black = () => {
  return (
    
    <div className='black-bg-full'>

    </div>
  )
}

export default Black